{
  "name": "carool-web-app",
  "version": "9.5.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test carool-web-app",
    "test-ci": "ng test carool-web-app --watch=false --browsers=Headless",
    "test-cypress": "TZ=Europe/Paris npx cypress run --e2e --reporter junit --browser chrome",
    "test-spec": "node scripts/run-spec.js",
    "test-cypress-ci": "WAIT_ON_TIMEOUT=1200000 start-server-and-test start http://localhost:4200 test-cypress"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.4",
    "@angular/common": "^21.1.4",
    "@angular/compiler": "^21.1.4",
    "@angular/core": "^21.1.4",
    "@angular/forms": "^21.1.4",
    "@angular/platform-browser": "^21.1.4",
    "@angular/platform-browser-dynamic": "^21.1.4",
    "@angular/router": "^21.1.4",
    "@carool1/ngx-carool-ds": "2.14.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@sentry/angular": "^10.32.1",
    "@sentry/cli": "^3.0.1",
    "@types/google.maps": "^3.58.1",
    "angularx-qrcode": "21.0.4",
    "deepmerge-ts": "^5.1.0",
    "detect-browser": "^5.3.0",
    "dexie": "^4.0.11",
    "google-libphonenumber": "^3.2.40",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "ngx-matomo-client": "^9.0.1",
    "rxjs": "~7.8.1",
    "tslib": "^2.8.1",
    "web-animations-js": "^2.3.2",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.4",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.1.4",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/jasmine": "5.1.6",
    "@types/lodash": "4.17.15",
    "@types/node": "^18.16.12",
    "@types/qrcode": "^1.5.5",
    "autoprefixer": "^10.4.2",
    "cypress": "^15.8.1",
    "cypress-network-idle": "^1.15.0",
    "jasmine-core": "~5.0.1",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "8.5.2",
    "start-server-and-test": "^2.0.0",
    "tailwindcss": "3.0.23",
    "typescript": "~5.9.2"
  }
}
